import { useMutation, useQueryClient } from "@tanstack/react-query";
import { logoutFetch } from "store/middlewares/auth.crud";
import { useNavigate } from "react-router-dom";
import { app } from "router/routes";
import { secretStorage } from "config";
import { useDispatch } from "react-redux";
import { useCallback } from "react";

const useLogout = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const queryClient = useQueryClient()

    const { mutateAsync: logoutRQ, isPending: logoutPending } = useMutation({
        mutationFn: logoutFetch,
        onSettled: () => {
            dispatch({ type: "RESET_ALL_REDUCERS" })
        },
        onSuccess: () => {
            queryClient.clear()
            secretStorage.clean()
        }
    })

    const logout = useCallback(async () => {
        const isSSOUser = localStorage.getItem("sso_user") === "true";
        const redirectUrl = encodeURIComponent(process.env.REACT_APP_PORT);

        // 1. קריאה לשרת שלך (Python) לניקוי ה-Session המקומי (חשוב מאוד!)
        try {
            await logoutRQ();
        } catch (error) {
            console.error("Local logout failed, continuing to SSO logout", error);
        }

        // 2. ניקוי יסודי של ה-Storage המקומי
        localStorage.clear(); // מומלץ לנקות הכל כדי למנוע שאריות מידע
        sessionStorage.clear();

        if (isSSOUser) {
            // שימוש ב-window.location.replace מונע מהמשתמש לחזור אחורה לדף המחובר
            const sloUrl = ` https://is.remote.education.gov.il/nidp/jsp/logoutSuccess.jsp?logoutURL=${redirectUrl}`;

            https://is.remote.education.gov.il/nidp/jsp/logoutSuccess.jsp?logoutURL=%5bURL%5d
            window.location.replace(sloUrl);
        } else {
            // משתמש רגיל - הפנייה לדף הבית או התחברות
            navigate(app.login);
        }
    }, [logoutRQ, navigate]);

    return { logout, logoutPending }
}

export default useLogout